export default {
  // Auth Endpoints
  logEndpoint: '/auth/login',
  loginEndpoint: '/auth/login',
  logoutEndpoint: '/auth/logout',
  registerEndpoint: '/auth/register',
  confirmTokenValidityEndpoint: '/auth/check',

  logsEndpoint: '/auth/logs',
  confirmEmailEndpoint: '/auth/confirm-email',
  confirmPhoneEndpoint: '/auth/confirm-phone',
  registrationSettingsEndpoint: '/auth/registration/settings',
  requestPhoneVerificationEndpoint: '/auth/request-phone-verification',

  resetPasswordEndpoint: '/auth/reset-password',
  changePasswordEndpoint: '/auth/password/change',
  requestPasswordResetEndpoint: '/auth/request-password-reset',
  resendConfirmEmailEndpoint: '/auth/account/confirmation/resend',
  checkPasswordResetValidityEndpoint: '/auth/check-password-reset-token',

  onboardingEndpoint: '/auth/onboarding',
  completeOnboardEndpoint: '/auth/onboard',
  updateUserProfileEndpoint: '/auth/profile',
  userNotificationsEndpoint: '/auth/notifications',
}
